<template>
  <div class="section section_no-padding">
    <div class="hero">
      <div class="max-width">
        <div class="hero__grid">
          <div class="hero__about">
            <h1 class="section__title">{{ title }}</h1>
            <div class="section__text">{{ text }}</div>
            <div class="section__buttons">
              <a :href="purchaseLink" class="button button_white" target="_blank">
                Purchase Now
                <span>{{ price }}</span>
              </a>
              <a :href="previewLink" class="button button_white-border" target="_blank">
                Live Preview
                <slot name="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 25 24"><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M12.023 7.625a4.375 4.375 0 1 0 0 8.75a4.375 4.375 0 0 0 0-8.75M9.148 12a2.875 2.875 0 1 1 5.75 0a2.875 2.875 0 0 1-5.75 0"/><path d="M12.023 4.5c-4.312 0-8.025 2.556-9.722 6.235a3.02 3.02 0 0 0 0 2.53c1.697 3.679 5.41 6.235 9.722 6.235s8.026-2.556 9.723-6.235c.37-.802.37-1.728 0-2.53c-1.697-3.679-5.41-6.235-9.723-6.235m-8.36 6.863C5.125 8.194 8.32 6 12.023 6c3.704 0 6.899 2.194 8.36 5.363c.187.404.187.87 0 1.274C18.923 15.806 15.728 18 12.024 18s-6.898-2.194-8.36-5.363a1.52 1.52 0 0 1 0-1.274"/></g></svg>
                </slot>
              </a>
            </div>
          </div>

          <div class="hero__pic">
            <img :src="imgMain" :srcset="imgSet" loading="lazy" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroView',
  props: {
    title: { type: String, required: true },
    text: { type: String, required: true },
    purchaseLink: { type: String, required: true },
    previewLink: { type: String, required: true },
    price: { type: String, default: '$0' },
    imgMain: { type: String, required: true },
    imgSet: { type: String, required: false },
  }
}
</script>

<style lang="scss">
  .hero {
    background:url('@/assets/imgs/hero-bg.webp') no-repeat 50% 100%;
    background-size:cover;
    padding:8.75rem 0 0;

    @include xs {
      padding:7rem 0 0;
    }

    &__grid {
      display:flex;
      justify-content:space-between;
      gap:3rem;

      @include lg {
        flex-direction:column;
        gap:2.5rem;
        align-items:center;
      }
    }

    &__about {
      padding-top:1.75rem;
      max-width:456px;
      flex:none;

      @include lg {
        padding:0;
        max-width:580px;
        text-align:center;
      }

      .section__title {
        color:#fff;
      }

      .section__text {
        color:#fff;
        opacity:.6;
      }

      .section__buttons {
        flex-wrap:wrap;

        @include lg {
          justify-content:center;
        }

        .button {
          @include xs {
            padding:0;
            flex:auto;
          }

          &_white-border {
            gap:6px;

            svg {
              width:22px;
              height:auto;
              transform:none;
            }
          }
        }
      }
    }

    &__pic {
      img {
        filter:drop-shadow(0 0 29px rgba(127, 127, 127, 0.1));
      }
    }
  }
</style>
